import { useAutoAnimate } from '@formkit/auto-animate/react'
import cn from 'classnames'
import ChevronIcon from 'ext-ui/svg/icon/ChevronIcon'
import React, { ComponentProps, ReactElement, useState } from 'react'

import style from './AlertBanner.style'

type AlertBannerProps = {
  className?: string
  variant?: 'soft' | 'warning' | 'severe' | 'new'
  icon?: ReactElement
  title: string
  isCollapsible?: boolean
  // If non interactable, this prop is safe to remove
  'data-testid': string
} & ComponentProps<'div'>

function AlertBanner(props: AlertBannerProps): ReactElement {
  const {
    className = '',
    variant = 'soft',
    title,
    icon,
    isCollapsible = false,
    children,
    ...rest
  } = props

  const [open, setOpen] = useState<boolean>(true)
  const [containerRef] = useAutoAnimate()

  return (
    <div
      className={cn('AlertBanner', className, variant, {
        topAlign: children !== undefined,
      })}
      css={style}
      {...rest}
    >
      {icon && <div className={'AlertBanner-icon'}>{icon}</div>}
      <div className={'flex-column w-full'}>
        <div className={'flex-row gap-1 align-center justify-between'}>
          <span className={'font-md font-weight-medium text-primary'}>
            {title}
          </span>
          {isCollapsible && children && (
            <ChevronIcon
              className={'AlertBanner-chevron'}
              direction={open ? 'up' : 'down'}
              onClick={() => setOpen((isOpen: boolean) => !isOpen)}
            />
          )}
        </div>
        {children && (
          <div ref={containerRef}>
            {open && (
              <div
                className={'collapsible font-md text-primary flex-column gap-2'}
              >
                {children}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default AlertBanner
